import { ChangeEvent, FC } from 'react'

import {
  Button,
  Form,
  Grid,
  Input,
  Picker,
  Row,
  Select,
  SelectForm,
  Span
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import moment from 'moment'
import { ParamFaleConoscoResponseDto } from 'services/NGT/Parameterization'
import { SPACING } from 'utils'
import { Control } from 'react-hook-form'
import { TalkToUsSearchProps } from '..'

interface IFilterSearchTalkToUsProps {
  control: Control<TalkToUsSearchProps, any>
  handleOnSearch: (_form?: TalkToUsSearchProps) => void
  areDatesValid: () => boolean
  handleOnClear: () => void
  errors: any
  parametrizationTalkToUs: ParamFaleConoscoResponseDto[]
  handleSubmit: any
  // searchParams: ITalkToUsRequestDto
  // handleOnChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const FilterSearchTalkToUs: FC<IFilterSearchTalkToUsProps> = ({
  handleOnClear,
  handleOnSearch,
  areDatesValid,
  parametrizationTalkToUs,
  errors,
  control,
  handleSubmit
  // handleOnChange,
  // searchParams
}) => {


  function handleSubmitForm(form: TalkToUsSearchProps) {
    handleOnSearch(form)
  }

  return (
    <Form
      onSubmit={handleSubmit(handleSubmitForm)}
    >
      <Grid
        gridCols="1fr 1.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <SelectForm
          label="Motivo"
          formValue="idMotivo"
          control={control}
          // clearSelect
          listOptions={parametrizationTalkToUs.map((motivo: ParamFaleConoscoResponseDto) => ({
            label: motivo?.dsMotivo,
            value: motivo?.idParamFaleConosco
          }))}
        // value={searchParams.idMotivo}
        // onChange={handleOnChange}
        />
      </Grid>
      <Grid
        gridCols="1.5fr 0.1fr 1.5fr 2fr 6fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Picker
          formValue="dtEnvioInicio"
          errors={errors}
          label="Data de"
          control={control}
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          formValue="dtEnvioFim"
          errors={errors}
          control={control}
          label="Data até"
        />
        <SelectForm
          label="Status"
          formValue="flLiberado"
          control={control}
          listOptions={[
            { label: 'Respondido', value: 'true' },
            { label: 'Não Respondido', value: 'false' }
          ]}
        />
        <Row justifyContent="flex-end" marginTop={SPACING.spacing10}>
          <Button text="Limpar" variantButton="text" onClick={handleOnClear} />
          <Button
            text="Pesquisar"
            endIcon={<MagnifyingGlassIcon />}
            disabled={!areDatesValid()}
            type={'submit'}
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
          />
        </Row>
      </Grid>
    </Form>
  )
}

export default FilterSearchTalkToUs
